const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

/**
 * Preserve trusted focus/deep-link parameters while retiring the historical
 * standalone Matter Workspace route in favor of canonical Chat Projects.
 */
export function buildLegacyProjectsRedirectTarget(
  search: string,
  pathProjectId?: string | null,
): string {
  const params = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search);
  const normalizedPathProjectId = pathProjectId?.trim() ?? '';

  if (!params.has('project_id') && UUID_RE.test(normalizedPathProjectId)) {
    params.set('project_id', normalizedPathProjectId);
  }

  const query = params.toString();
  return query ? `/chat?${query}` : '/chat';
}
